import { useState, useEffect } from 'react';

const parseHashParams = (hash: string) => {
  const params = new URLSearchParams(hash.slice(1));
  const paramsObject: { [key: string]: string } = {};
  params.forEach((value, key) => {
    paramsObject[key] = value;
  });
  return paramsObject;
};

const useUtmParams = () => {
  const [utmSource, setUtmSource] = useState<string>('');
  const [utmMedium, setUtmMedium] = useState<string>('');
  const [utmCampaign, setUtmCampaign] = useState<string>('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // 初期ロード時にセッションストレージからパラメータを読み込む
      const storedUtmSource = sessionStorage.getItem('utm_source');
      const storedUtmMedium = sessionStorage.getItem('utm_medium');
      const storedUtmCampaign = sessionStorage.getItem('utm_campaign');

      if (storedUtmSource) setUtmSource(storedUtmSource);
      if (storedUtmMedium) setUtmMedium(storedUtmMedium);
      if (storedUtmCampaign) setUtmCampaign(storedUtmCampaign);

      const params = parseHashParams(window.location.hash);
      if (params['utm_source']) {
        setUtmSource(params['utm_source']);
        sessionStorage.setItem('utm_source', params['utm_source']);
      }
      if (params['utm_medium']) {
        setUtmMedium(params['utm_medium']);
        sessionStorage.setItem('utm_medium', params['utm_medium']);
      }
      if (params['utm_campaign']) {
        setUtmCampaign(params['utm_campaign']);
        sessionStorage.setItem('utm_campaign', params['utm_campaign']);
      }
    }
  }, []);

  return { utmSource, utmMedium, utmCampaign };
};

export default useUtmParams;